var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0859 0.0742188H2.08594C0.982937 0.0742188 0.0859375 0.971219 0.0859375 2.07422V14.0742C0.0859375 15.1772 0.982937 16.0742 2.08594 16.0742H8.08594V10.5742H6.08594V8.07422H8.08594V6.07422C8.08594 5.27857 8.40201 4.51551 8.96462 3.9529C9.52723 3.39029 10.2903 3.07422 11.0859 3.07422H13.0859V5.57422H12.0859C11.5339 5.57422 11.0859 5.52222 11.0859 6.07422V8.07422H13.5859L12.5859 10.5742H11.0859V16.0742H14.0859C15.1889 16.0742 16.0859 15.1772 16.0859 14.0742V2.07422C16.0859 0.971219 15.1889 0.0742188 14.0859 0.0742188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.8ab8f76572ef52adc797de664d622041.svg";
export { ForwardRef as ReactComponent };